<template>
  <div class="navbar-container">
    <div class="title font-weight-black">
      {{ title }}
    </div>
    <div v-if="button" class="action-button">
      <v-btn class="gorate-btn-bg" rounded="xl" variant="flat" @click="handleNavBarClick">{{ buttonText }}</v-btn>
    </div>
    <!-- <div v-if="isMobileView" class="avatar-container">
      <UserAvatar />
    </div> -->
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useAppStore } from '@/stores/appStore'

export default defineComponent({
  name: 'ContentContainerNavBar',
  components: {
    /* UserAvatar */
  },
  props: {
    title: {
      type: String,
      required: true,
      default: 'N/A'
    },
    button: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonText: {
      type: String,
      required: false,
      default: 'Button'
    },
    buttonEvent: {
      type: String,
      required: false,
      defaut: 'navbar-btn-click'
    }
  },
  setup() {
    const appStore = useAppStore()

    return {
      appStore
    }
  },
  methods: {
    handleNavBarClick() {
      if (this.buttonEvent !== undefined) {
        this.$emit(this.buttonEvent)
      } else {
        this.$emit('navbar-btn-click')
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../styles/colors.scss";

.navbar-container {
  grid-row: 1;
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  align-items: center;

  padding: 0em 1.0em;

  min-height: 4em;

  background-color: $white;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);

  .navbar-title {
    padding: 0.8em 0.4em 0.8em 2.0em;
    font-weight: bold;
  }

  .toolbar {
    display: grid;
    align-items: center;
  }
}

/* MOBILE */
@media (max-width: 960px) {
  .navbar-container {
    grid-template-columns: 1fr;
    justify-content: start;
    gap: 1em;
    padding: 1em 1em;
  }
}
</style>
